
import './Statistica.css';
import ReactModal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

type Props = {
    showNotes: boolean;
    setShowNotes: (showNotes: boolean) => void;
    currentClient: any,
    setCurrentClient: (client: any) => void;
}

function BillingNotes(props: Props) {

    const {
        showNotes,
        setShowNotes,
        currentClient,
        setCurrentClient,
    } = props

    const closeModal = () => {
        setShowNotes(false);
        setCurrentClient(null);
    }

    return (
        <ReactModal
            isOpen = { showNotes }
            onRequestClose = { closeModal }
            bodyOpenClassName = 'no-scroll'
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    position: 'relative',
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    transform: 'translate(-50%, -50%)',
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "500px",
                    minHeight: '150px',
                    height: "auto",
                    border: 'none',
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "flex-start",
                    justifyContent: "center",
                }
            }}
        >
            <CloseIcon
                style = {{
                    position: 'absolute',
                    right: '15px',
                    top: '15px',
                    color: 'gray',
                    cursor: 'pointer',
                }}
                onClick = { closeModal }
                titleAccess = {'Close'}
            />
            <span style = {{ marginTop: '10px', fontWeight: 'bold' }}>Billing Notes</span>
            <span className = 'serviceReasonText'>
                { currentClient?.billingNotes  }
            </span>
            <span style = {{ marginTop: '10px', fontWeight: 'bold' }}>Comments</span>
            {
                currentClient?.comments.map((item: any) => (
                    <div className = 'serviceReasonText'>{ item.text }</div>
                ))
            }
        </ReactModal>
    )
}

export default BillingNotes
